import React, { useState } from "react";
import { useLang } from "../context/LanguageContext";
import { useReveal } from "../hooks/useReveal";
import { PageBanner, PackageCard } from "../components/Shared";
import { useContent } from "../context/ContentContext";

const Packages = ({ type }) => {
  const { t } = useLang();
  const { PACKAGES, IMAGES } = useContent();
  const [filter, setFilter] = useState(type || "all");
  useReveal([filter]);

  const title =
    type === "hajj" ? t.nav.hajj : type === "umrah" ? t.nav.umrah : t.sec.packages_title;

  const list = PACKAGES.filter((p) => {
    if (type) return p.type === type;
    if (filter === "all") return true;
    return p.type === filter;
  });

  return (
    <div>
      <PageBanner
        title={title}
        subtitle={t.sec.packages_sub}
        image={type === "hajj" ? IMAGES.arafat : IMAGES.pageBanner}
      />

      <section className="section-pad bg-jannah-cream">
        <div className="max-w-7xl mx-auto px-6">
          {!type && (
            <div className="flex justify-center gap-3 mb-12">
              {[
                { k: "all", label: t.filter_all },
                { k: "hajj", label: t.filter_hajj },
                { k: "umrah", label: t.filter_umrah },
              ].map((f) => (
                <button
                  key={f.k}
                  onClick={() => setFilter(f.k)}
                  className={`px-6 py-2.5 rounded-full font-semibold text-sm border-2 ${
                    filter === f.k
                      ? "bg-jannah-green text-white border-jannah-green"
                      : "border-jannah-green/30 text-jannah-green hover:bg-jannah-green/10"
                  }`}
                >
                  {f.label}
                </button>
              ))}
            </div>
          )}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {list.map((p) => (
              <div key={p.id} className="reveal">
                <PackageCard pkg={p} />
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Packages;
